/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {BuilderQuestionnaire} from "../../../classes/questionnaire-builder/builder-questionnaire";

export interface QuestionnaireBuilderModelGetParams {
    questionnaireGuid: string
}

export function questionnaireBuilderModelGet(http: HttpClient, rootUrl: string, params: QuestionnaireBuilderModelGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<BuilderQuestionnaire>> {
    const rb = new RequestBuilder(rootUrl, questionnaireBuilderModelGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        rb.query('questionnaireGuid', params.questionnaireGuid);
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<BuilderQuestionnaire>;
        })
    );
}

questionnaireBuilderModelGet.PATH = '/api/v1/questionnaires/edit-model';
